<template>
  <div slot="body" v-if="dataLoaded">
    <bita-form ref="form">
      <div slot="body">
        <div class="row">
          <bita-select
            name="feature_id"
            ref="featureSelect"
            label="شاخص"
            rules=""
            validation-container-class="col-3"
            input-class="form-control"
            :data-source="features"
            data-text-field="name"
            data-value-field="id"
            v-model="featureID"
          />
          <bita-formbutton
            title="افزودن شاخص"
            btn-width="col-lg-3"
            buttonType="btn-w-m btn-primary"
            @click="addFeature()"
          />
        </div>
        <div class="row" v-if="isUpdateMode">
          <template v-for="(fID, index) in featureIDs">
            <div :key="index" class="feature-badge">
              <a @click="removeFeature(fID, index)" href="#"
                ><i class="fas fa-times-circle badge-close"></i
              ></a>
              {{ findFeatureNames(fID) }}
            </div>
          </template>
        </div>
        <div class="row" v-else>
          <template v-for="(fID, index) in featureIDs">
            <form-button
               :key="index+'-remove'"
                title="-"
                button-type="btn-danger small"
                @click="deleteCombination(fID,index)"
              />
            <bita-multiselect
              :key="index"
              :name="'feature_value_id' + index + fID"
              ref="featureValueSelect"
              :label="findFeatureNames(fID)"
              rules="required"
              :validation-container-class="largeColWidth"
              input-class="form-control"
              :data-source="findFeatureValues(fID)"
              data-text-field="name"
              data-value-field="id"
              v-model="tempCombinations[fID]"
            />
          </template>
          <bita-formbutton
            title="ایجاد تنوع ها"
            btn-width="col-lg-3"
            buttonType="btn-w-m btn-primary"
            @click="generateCombinations()"
          />
        </div>
        <hr />
        <template v-for="(price, index) in productPrices">
          <div :key="index">
            <div class="row">
              <form-button
                title="-"
                button-type="btn-danger"
                v-if="deletable()"
                @click="deletePrice(index, price)"
              />
              <bita-input
                type="text"
                :name="'code' + index"
                label="کد"
                rules=""
                :validation-container-class="largeColWidth"
                input-class="form-control"
                v-model="price.id"
              />
              <bita-input
                type="text"
                :name="'barcode' + index"
                label="بارکد"
                rules=""
                :validation-container-class="largeColWidth"
                input-class="form-control"
                v-model="price.barcode"
              />
              <bita-input
                type="text"
                :name="'price' + index"
                :label="$currencyLabel('قیمت')"
                :has-thousand-seprator="true"
                rules="required"
                :validation-container-class="largeColWidth"
                input-class="form-control"
                v-model="price.price"
              />
              <bita-input
                type="text"
                :name="'name' + index"
                label="نام"
                rules="required"
                :validation-container-class="largeColWidth"
                input-class="form-control"
                v-model="price.name"
              />
            </div>
            <div class="row">
              <template v-for="(fID, index1) in featureIDs">
                <div :key="index1" :class="largeColWidth">
                  <v-validate
                    rules="required"
                    :name="findFeatureNames(fID)"
                    v-slot="{ errors, classes }"
                  >
                    <div class="form-group">
                      <label>
                        {{ findFeatureNames(fID) }}
                        <div class="is-required">*</div>
                      </label>
                      <div>
                        <select
                          :class="
                            `form-control ${
                              classes.invalid ? 'is-invalid' : ''
                            }`
                          "
                          v-model="
                            productPrices[index].mapped_combinations[fID]
                          "
                        >
                          <option
                            v-for="(item, index) in findFeatureValues(fID)"
                            :key="index"
                            :value="item.id"
                            >{{ item.name }}</option
                          >
                        </select>
                        <span class="invalid-feedback">{{ errors[0] }}</span>
                      </div>
                    </div>
                  </v-validate>
                </div>
              </template>
              <block-button
                v-if="productPrices.length == index + 1"
                icon="fas fa-plus-circle"
                @click="addPrice()"
              />
            </div>
            <div class="row"></div>
          </div>
        </template>
      </div>
    </bita-form>
  </div>
</template>
<script>
import BlockButton from "@/components/template/buttons/BlockButton";
import FormButton from "@/components/template/buttons/FormButton";
import { productApi } from "@/api/apiManagement";
import combinate from "combinate";

export default {
  props: {
    title: String,
    isLoading: Boolean,
    largeColWidth: {
      default: "col-lg-2",
    },
    smallColWidth: {
      default: "col-lg-2",
    },
    product: {},
    isUpdateMode: false,
  },
  components: { BlockButton, FormButton },
  data() {
    return {
      form: {},
      productPrices: [],
      formData: [{}],
      featureID: "",
      featureIDs: [],
      tempCombinations: {},
      productId: "",
      features: [],
      dataLoaded: false,
    };
  },
  computed: {
    formRef() {
      return this.$refs.form;
    },
    featureKeyedArray() {
      let res = {};
      for (var feature of this.features) {
        res[feature.id] = "";
      }
      return res;
    },
  },
  methods: {
    setInitialValue(_data) {
      this.features = [];
      this.form = _data;
      if (this.form.id) {
        this.loadData();
      }
    },
    deletable() {
      return this.productPrices.length > 1;
    },
    removeFeature(featureID, index) {
      this.featureIDs.splice(index, 1);
      this.$forceUpdate();
    },
    deleteCombination(featureID, index) {
      console.log(this.featureIDs,featureID, index)
      this.featureIDs.splice(index, 1);
      delete this.tempCombinations[featureID];

      this.$forceUpdate();
    },
    addFeature() {
      if (this.featureID && !this.featureIDs.includes(Number(this.featureID))) {
        this.featureIDs.push(this.featureID);
        // if (this.isUpdateMode) this.featureSelect.emptyKendo();
        if (!this.isUpdateMode) this.tempCombinations[this.featureID] = {};
        this.featureID = "";
        this.$forceUpdate();
      }
    },
    generateCombinations() {
      this.productPrices = [];

      for (const combination in this.tempCombinations)
        if (JSON.stringify(this.tempCombinations[combination]) == "{}")
          delete this.tempCombinations[combination];

      let combinations = combinate(this.tempCombinations);
      for (let counter = 0; counter < combinations.length; counter++) {
        this.productPrices.push({ mapped_combinations: combinations[counter] });
      }
    },
    save() {
      return new Promise((resolve, reject) => {
        this.$refs.form.validate().then((result) => {
          if (result) {
            this.$emit("is-loading", true);

            productApi
              .updateProductPrices(this.form.id, {
                prices: this.productPrices,
                feature_ids: this.featureIDs,
                product_id: this.productId,
              })
              .then((res) => {
                this.reset();
                this.$emit("on-update", this.form);
                resolve(true);
              })
              .finally(() => {
                this.$emit("is-loading", false);
              })
              .catch((err) => {
                reject(err);
              });
          } else reject(false);
        });
      });
    },

    addPrice() {
      let mapped_combinations = [];
      mapped_combinations.push(this.featureKeyedArray);
      this.productPrices.push({ mapped_combinations });
    },

    findFeatureValues(featureID) {
      let res = collect(this.features)
        .where("id", Number(featureID))
        .first();
      return res ? res.feature_values : [];
    },

    findFeatureNames(featureID) {
      let res = collect(this.features)
        .where("id", Number(featureID))
        .first();
      return res ? res.name : "-";
    },

    deletePrice(index, price) {
      if (!price.id) return this.$delete(this.productPrices, index);
      this.$emit("is-loading", true);

      productApi
        .deleteProductPrice(price.id)
        .then((res) => {
          this.$delete(this.productPrices, index);
          this.$izitoast("success", "عملیات موفق", res.data.message);
        })
        .finally(() => this.$emit("is-loading", false));
    },

    loadData() {
      this.$emit("is-loading", true);
      Promise.all([
        productApi.getProductPrices(this.form.id),
        productApi.getProductFeaturables(this.form.id),
      ])
        .then((res) => {
          var prices = res[0].data.entity;
          this.features = res[1].data.entity;
          this.productId = prices[0].product_id;
          var combinations = [];
          for (var price of prices) {
            for (var combination of price.combinations) {
              combinations.push(combination);
            }
          }
          var featureIDs = collect(combinations)
            .pluck("feature_id")
            .unique()
            .toArray();
          this.featureIDs = featureIDs;

          for (let a of res[0].data.entity) {
            this.productPrices.push({
              mapped_combinations: this.featureKeyedArray,
            });
          }
          this.dataLoaded = true;
          setTimeout(() => {
            this.featureIDs = featureIDs;
          }, 50);
          setTimeout(() => {
            this.productPrices = res[0].data.entity;
          }, 100);
          this.$forceUpdate();
        })
        .finally(() => {
          setTimeout(() => {
            this.$emit("is-loading", false);
          }, 120);
        });
    },

    validate() {
      return this.$refs.form.validate();
    },

    setErrors(err) {
      this.$refs.form.setErrors(err);
    },

    reset() {
      if (this.$refs.featureSelect) this.$refs.featureSelect.emptyKendo();
      if (this.formRef && this.formRef.reset()) this.formRef.reset();
      this.dataLoaded = false;
      this.form = {};
      this.productPrices = [];
      this.featureIDs = null;
    },
  },
};
</script>

<style scoped>
.feature-badge {
  padding: 5px 21px;
  margin: 5px;
  background: #1ab394;
  border-radius: 10px;
  color: #fff;
  position: relative;
}
.badge-close {
  color: #ed5565;
  font-size: 18px;
  position: absolute;
  left: -2px;
  top: -3px;
}
</style>
